import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './common/assets/styles/main.scss';
import reportWebVitals from './reportWebVitals';
import CircularProgress from '@mui/material/CircularProgress';
import './i18n';
import { Provider } from 'react-redux';
import ServicesContext from './contexts/servicesContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	// <React.StrictMode>
		<Suspense fallback={<CircularProgress />}>
			<App />
		</Suspense>
	// </React.StrictMode>
);
reportWebVitals();
